import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'sanitize',
})
export class SanitizePipe implements PipeTransform {
  private sanitized = inject(DomSanitizer);

  transform(value: string | null): string | null {
    if (!value) {
      return '';
    }

    return this.sanitized.sanitize(SecurityContext.HTML, value);
  }
}
